export const SET_CURRENT_ECGS = 'SET_CURRENT_ECGS'
export const SET_ECG_LOADING = 'SET_ECG_LOADING'
